import React from "react";

function RightArrow() {
  return (
    <svg
      width="38"
      height="43"
      viewBox="0 0 38 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36 18.0359C38.6667 19.5755 38.6667 23.4245 36 24.9641L6.75001 41.8516C4.08334 43.3912 0.749998 41.4667 0.749998 38.3875L0.75 4.61251C0.75 1.53331 4.08333 -0.391199 6.75 1.1484L36 18.0359Z"
        fill="white"
      />
    </svg>
  );
}

export default RightArrow;
